const prevBindFn = (size) => {
  switch (size) {
    case 'small':
      return '16px';
    case 'medium':
      return '20px';
    case 'big':
      return '24px';
    default:
      return '20px';
  }
};

export default (props, vars) =>
  typeof prevBindFn === 'function' ? prevBindFn(props?.['size']) : prevBindFn;
